const data = {
  fastcompany: {
    logo:
      '//a.fastcompany.net/image/upload/v1488299125/fc/fastcompany-logo.svg',
    title: 'Fast Company',
    subscribeLink: 'https://www.fastcompany.com/combo',
    newsletterLink: 'https://www.fastcompany.com/newsletters',
    topics: [
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/co-design',
        title: 'Design'
      },
      {
        url: '/leadership-2',
        title: 'Leadership'
      },
      {
        url: '/work-life',
        title: 'Work Life'
      },
      {
        url: '/most-innovative-companies/list',
        title: 'Most Innovative Companies'
      },
      {
        url: '/games',
        title: 'Games'
      },
      {
        url: '/podcasts',
        title: 'Podcasts',
        removeOnScale: true,
        external: true
      },
      {
        url: '/videos',
        title: 'Video'
      },
      {
        url: '/events',
        title: 'Events'
      }
    ],
    sideNavTopics: [
      {
        url: '/news',
        title: 'News'
      },
      {
        url: '/technology',
        title: 'Tech'
      },
      {
        url: '/co-design',
        title: 'Design'
      },
      {
        url: '/leadership-2',
        title: 'Leadership'
      },
      {
        url: '/work-life',
        title: 'Work Life'
      },
      {
        url: '/most-innovative-companies/list',
        title: 'Most Innovative Companies'
      },
      {
        url: '/games',
        title: 'Games'
      },
      {
        url: '/lists',
        title: 'Lists'
      },
      {
        url: '/section/financing-the-future',
        title: 'Financing the Future'
      },
      {
        url: '/podcasts',
        title: 'Podcasts',
        removeOnScale: true,
        external: true
      },
      {
        url: '/videos',
        title: 'Video'
      }
    ],
    channels: [
      {
        logo: '',
        title: 'Custom Studio',
        items: [
          {
            url: '/fcw/ibm',
            title: 'IBM'
          },
          {
            url: '/fcw/texas-am-university',
            title: 'Texas A&M University'
          }
        ]
      }
    ]
  }
};

export default data;
